import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {FileManagementService} from '@core/services/file-management.service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {DownloadFormErrorCommand} from '../../../commands/dac6-reporter.command';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';

@Component({
    standalone: false,
    selector: 'particle-transmission-view-details-dialog',
  templateUrl: './transmission-view-details-dialog.component.html',
  styleUrls: ['./transmission-view-details-dialog.component.scss']
})
export class TransmissionViewDetailsDialogComponent implements OnInit, IDialogView, OnDestroy {

  data: DialogModel;

  constructor(private fileManagementService: FileManagementService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private commandService: CommandService, private snackBarService: SnackBarService) {
  }

  item: any;

  ngOnInit() {
    try {
      this.item = this.data.input.item;
      console.log(this.item);
    } catch (e) {
      console.error(e);
    }
  }

  ngOnDestroy(): void {
  }

  onOkClicked(): boolean {
    return true;
  }

  downloadDAC6Report() {
    if (this.item && this.item.ActualFile && this.item.ActualFile.value && this.item.ActualFile.value.fileId) {
      this.fuseSplashScreenService.show();
      this.fileManagementService.downloadClientFileWithId(this.item.ActualFile.value.fileId).subscribe(payload => {
        this.fuseSplashScreenService.hide();
        this.fileManagementService.openSaveFileWindow(payload, `${this.item.CaseId.displayText}.xml`);
      });
    }
  }

  downloadErrorReport() {
    const self = this;
    if (self.item.ExcelErrorReportId && self.item.ExcelErrorReportId.value) {
      self.fuseSplashScreenService.show();
      self.commandService.executeCommand(new DownloadFormErrorCommand(self.item.ExcelErrorReportId.value)).subscribe(response => {
        if (response && response.Payload.FileId && response.Payload.HasError) {
          self.fileManagementService.downloadClientFileWithId(response.Payload.FileId).subscribe(payload => {
            self.fuseSplashScreenService.hide();
            self.fileManagementService.openSaveFileWindow(payload, response.Payload.FileName);
          });
        } else {
          self.fuseSplashScreenService.hide();
          self.snackBarService.showInformation('No error exists.');
        }
      });
    } else {
      self.snackBarService.showInformation('No error exists.');
    }
  }
}
